define('lib/validator/ValidatorInterval',['require','lib/validator/ValidatorAbstract'],function (require) {

	var ValidatorAbstract = require('lib/validator/ValidatorAbstract');
	
	return ValidatorAbstract.extend({


        options : {
            min : 1,
            max : 5,
            error : 'error_interval_is_not_valid',
        },
		
		/**
		 * Validates value
		 *  
		 * @param mixed value
		 */
		validate: function (value) {
			if (parseInt(value) > this.options.max || parseInt(value) < this.options.min) {
                this.addError(this.options.error);
            }
		}
	
	});
	
});
